module.exports = __webpack_public_path__ + "img/menu.f7aba9de.svg";